

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface TenantBranchParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface TenantBranch {
  noofPharmacyCounter? : number, 
    id?: string;
    branchUserId: string;
    branchName: string;
    name: string;
    branchCode: string;
    area: string;
    tenantId?: string;
    contNum: string;
    alterMobile: string;
    email: string;
    website?:string;
    street:string;
    city:string;
    country:string;
    state:string;
    district:string;
    pincode:string;
    logo?:string;
    isDefault:string;
    tds?:number;
    mobileCountryCode?:string;
    timeZone?:string;

    activeFlag?:string;
    createdDate?:Date;
    createdBy:string;

    timeFormat?: string,
    timeSymbol?: string,
    dateFormatValue?: string,
    currencySymbol?: string,
    noofDigitAfterDecimal?: number,
    digitGrouping?: number
    facilityId?:string,
    categoryWiseBill?:string;
    colorCodeOption?: string;
    noOfHMSCounter?:number;
    sampleBasedBarcodeFlag?:boolean;
    serviceBasedBarcode:boolean;
    isAllowDuplicate?:boolean;
    isResultValue?:boolean;
    barcodePrintReport?:boolean;
    ledgerCurrency?: string

    commonTaxValue?:number;
    taxMethod?:number;
    hospitalConsultationType?:string;
    isVisibleToPatientPortal?:string;
  parameters?: TenantBranchParameter[];
  links?: any;
}


export interface onBoardNewCustomer {
    name: string;
    area:string;
    street:string;
    city:string;
    country:string;
    state:string;
    district:string;
    pincode:string;
    mobileCountryCode?:string;
    timeZone?:string;
    createdDate?:Date;
    contactName?:string;
    phoneNum?:string,
    password?:string,
    confirmPassword?:string,
    emailAddr?:string,
    other_AddPHNO?:string,
    noOfLicences?:number;
    noOfBranch?:number;
    subscriptionType:string; // Live or trial
    customerType:string; // onprem and/or Cloud
    parameters?: TenantBranchParameter[];
    links?: any;
    storageProvider?:Number;
    superAdminController:boolean;
    controlCenter:string;
    tenantCountryCode:string;
    noOfBeds?: number;
}

export abstract class TenantBranchData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract getById(url: string): Observable<any>;
  
  abstract list(url: string): Observable<TenantBranch[]>;
  abstract create(url: string,data: TenantBranch): Observable<any>;
  abstract update(url: string,data: TenantBranch): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract onBoardNewCustomer(url: string,data: onBoardNewCustomer): Observable<any>;

}

